// @ts-nocheck
import { useEffect, useLayoutEffect, useState } from "react";
// because of ssr isMobile can't access navigator or window before the first render so we need to set as null as default to avoid layout shift
const useIsMobile = ({ width = 768 } = {}) => {
    const isWindowUndefined = typeof window === "undefined";
    const [isMobile, setIsMobile] = useState<boolean | null>(null);
    useLayoutEffect(() => {
        if (isWindowUndefined) {
            return;
        }
        setIsMobile(window?.innerWidth <= width);
    }, [width, isWindowUndefined]);
    useEffect(() => {
        if (isWindowUndefined) {
            return;
        }
        const handleResize = () => {
            if (window && window?.innerWidth <= width) {
                if (!isMobile) {
                    setIsMobile(true);
                }
            } else if (isMobile) {
                setIsMobile(false);
            }
        };
        window?.addEventListener("resize", handleResize);

        handleResize();

        return () => {
            window?.removeEventListener("resize", handleResize);
        };
    }, [width, isMobile, isWindowUndefined]);

    return isMobile;
};

export default useIsMobile;
